/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerieSerieidLangsId200,
  GetApiV1SerieSerieidLangsId401,
  GetApiV1SerieSerieidLangsId404,
  GetApiV1SerieSerieidLangsId500,
  GetApiV1SerieSerieidLangsIdPathParams,
  GetApiV1SerieSerieidLangsIdQueryResponse,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangsId.ts";
import { serieLangViewModelSchema } from "../serieLangViewModelSchema.ts";

export const getApiV1SerieSerieidLangsIdPathParamsSchema = z.object({
  serieId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1SerieSerieidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerieSerieidLangsId200Schema = z.lazy(
  () => serieLangViewModelSchema,
) as unknown as ToZod<GetApiV1SerieSerieidLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerieSerieidLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerieSerieidLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerieSerieidLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1SerieSerieidLangsId500>;

export const getApiV1SerieSerieidLangsIdQueryResponseSchema = z.lazy(
  () => getApiV1SerieSerieidLangsId200Schema,
) as unknown as ToZod<GetApiV1SerieSerieidLangsIdQueryResponse>;
